export default __webpack_public_path__ + "static/media/thumbs-up.36506124.svg";